module.exports = __webpack_public_path__ + "static/img/1.72363f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/wechat/1.png
// module id = j1a8
// module chunks = 1